import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type MultilineFieldProps = {
  name: string;
  value: boolean;
  onChange: (value: any) => void;
};

const MultilineField = (props: MultilineFieldProps) => {
  return (
    <Autocomplete
      id="multiline"
      size="small"
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      value={props.value}
      options={[true, false]}
      autoHighlight
      getOptionLabel={(option: boolean) => (option ? "True" : "False")}
      fullWidth
      disableClearable
      renderInput={(params) => (
        <EditorVisualTextField
          {...params}
          name={props.name}
          fullWidth
          label="Multiline"
        />
      )}
    />
  );
};

export default MultilineField;
